<h2 mat-dialog-title>{{'pass.media_details' | translate}}</h2>

<mat-dialog-content>
  <div class="pt-2 pb-3">
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
      <form [formGroup]="mediaDetailsForm">

        <mat-form-field  appearance="outline" class="w-100 pb-2">
          <mat-label>URL</mat-label>
          <input formControlName="url" type="text" matInput placeholder="URL" data-nar="media-details-source-url">

          @if (data.translationMode) {
            <button mat-icon-button matSuffix [matMenuTriggerFor]="menu" matTooltip="{{'pick' | translate}}">
              <mat-icon> more_vert</mat-icon>
            </button>
          }
          <mat-menu #menu="matMenu">
            <button mat-menu-item type="button" (click)="triggerFileInput()">
              <mat-icon class="material-symbols-outlined">folder</mat-icon>{{'pass.browse' | translate}}
            </button>
            <input #urlFileInput type="file" id="urlFile" name="urlFile" style="display: none;" accept="['image/jpeg', 'image/png', 'image/webp']" (change)="readURL($event)">

            <button mat-menu-item type="button" (click)="browserFromMediaFolder()">
              <mat-icon class="material-symbols-outlined">perm_media</mat-icon>{{'pass.pick_media' | translate}}
            </button>

          </mat-menu>

          @if (mediaDetailsForm.controls['url']?.hasError('invalidCharacters')) {
            <mat-error>
              {{ 'invalid_characters' | translate }}
            </mat-error>
          }
          @if (mediaDetailsForm.controls['url']?.hasError('pattern') && !mediaDetailsForm.controls['url']?.hasError('invalidCharacters')) {
            <mat-error>
              {{ 'url_pattern_invalid' | translate }}
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field  appearance="outline" class="w-100 pb-2">
          <mat-label>{{'pass.fallbackUrl' | translate}}</mat-label>
          <input formControlName="fallbackUrl" type="text" matInput placeholder="{{'pass.fallbackUrl' | translate}}" data-nar="media-details-fallback-url">
          @if (mediaDetailsForm.controls['fallbackUrl']?.hasError('invalidCharacters')) {
            <mat-error>
              {{ 'invalid_characters' | translate }}
            </mat-error>
          }
          @if (mediaDetailsForm.controls['fallbackUrl']?.hasError('pattern') && !mediaDetailsForm.controls['fallbackUrl']?.hasError('invalidCharacters')) {
            <mat-error>
              {{ 'url_pattern_invalid' | translate }}
            </mat-error>
          }
        </mat-form-field>

        @if (!text && !image && !callToAction && !video && !billboardImage && !billboardVideo ) {
          <mat-form-field appearance="outline" class="w-100 pb-2">
            <mat-label>{{'pass.title' | translate}}</mat-label>
            <input formControlName="title" type="text" maxlength="40" matInput placeholder="{{'pass.title' | translate}}" data-nar="media-details-title">
            @if (mediaDetailsForm.get('title').hasError('maxlength') && mediaDetailsForm.get('title').touched) {
              <mat-error>
                {{ 'pass.field_maxlength' | translate }} 40
              </mat-error>
            }
            <mat-hint align="end">{{mediaDetailsForm.value?.title?.length}} / 40</mat-hint>
          </mat-form-field>
        }

        @if (!image && !callToAction && !billboardImage && !billboardVideo && !video) {
          <div class="d-flex flex-row">
            <mat-form-field appearance="outline" class="w-100 mb-2 link-field">
              <mat-label>{{ 'pass.link-URL' | translate }}</mat-label>
              @if (linkChip; as chip) {
                <mat-chip-set matPrefix class="link-chip-prefix">
                  <mat-chip-row (removed)="clearLinkChip()">
                    <div class="d-flex align-items-center">
                      <mat-icon class="material-symbols-outlined chip-icon">
                        {{ chip.kind === 'child' ? 'link' : 'anchor' }}
                      </mat-icon>
                      <span class="chip-text">{{ chip.label }}</span>
                      <button matChipRemove type="button" aria-label="Remove">
                        <mat-icon class="material-symbols-outlined">close</mat-icon>
                      </button>
                    </div>
                  </mat-chip-row>
                </mat-chip-set>
              }
              <input
                matInput
                formControlName="linkURL"
                type="url"
                placeholder="https://..."
                [readonly]="!!linkChip"
                [class.input-hidden]="!!linkChip"
                data-nar="media-details-link-url"
                />
              <button
                mat-icon-button
                matSuffix
                [matMenuTriggerFor]="linkMenu"
                matTooltip="{{ 'pick_link_target' | translate }}"
                type="button"
                >
                <mat-icon class="material-symbols-outlined">more_vert</mat-icon>
              </button>
              @if (mediaDetailsForm.controls['linkURL']?.hasError('invalidCharacters')) {
                <mat-error>
                  {{ 'invalid_characters' | translate }}
                </mat-error>
              }
              @if (mediaDetailsForm.controls['linkURL']?.hasError('pattern')
                && !mediaDetailsForm.controls['linkURL']?.hasError('invalidCharacters')) {
                <mat-error>
                  {{ 'url_pattern_invalid' | translate }}
                </mat-error>
              }
              <mat-hint>{{ 'url_pattern_detailed' | translate }}</mat-hint>
            </mat-form-field>
            <input type="file" id="myfile" name="myfile" style="display: none;" accept=".pdf, .jpg, .png, .jpeg, .doc, .docx, .xls, .xlsx, .txt, .csv, .vcf, .rtf, .webp" (change)="readDocument($event)" #fileInput>
            <!-- Main menu -->
            <mat-menu #linkMenu="matMenu">
              <ng-template matMenuContent let-button="button">
                @if (anchorOptions?.length) {
                  <button
                    mat-menu-item
                    [matMenuTriggerFor]="anchorMenu"
                    >
                    <mat-icon class="material-symbols-outlined">anchor</mat-icon>
                    <span>{{ 'pass.linkWidgetUrl' | translate }}</span>
                  </button>
                }
                @if (childPages?.length) {
                  <button
                    mat-menu-item
                    [matMenuTriggerFor]="childMenu"
                    >
                    <mat-icon class="material-symbols-outlined">link</mat-icon>
                    <span>{{ 'pass.linkChildPage' | translate }}</span>
                  </button>
                }
                <button
                  mat-menu-item
                  (click)="fileInput.click()"
                  matTooltip="{{'pick' | translate}}"
                  >
                  <mat-icon class="material-symbols-outlined">folder_open</mat-icon>
                  <span>{{'pass.browse' | translate}}</span>
                </button>
              </ng-template>
            </mat-menu>
            <!-- Anchors submenu -->
            <mat-menu #anchorMenu="matMenu">
              <ng-template matMenuContent let-button="button">
                <button mat-menu-item disabled>
                  {{ 'widgets' | translate }}
                </button>
                @for (a of anchorOptions; track a) {
                  <button
                    mat-menu-item
                    (click)="setLinkUrl(buildAnchorUrl(a))"
                    >
                    <span>{{ a.label || a.name || a.id }}</span>
                  </button>
                }
              </ng-template>
            </mat-menu>
            <!-- Child pages submenu -->
            <mat-menu #childMenu="matMenu">
              <ng-template matMenuContent let-button="button">
                <button mat-menu-item disabled>
                  {{ 'pass.pageTabLabels' | translate }}
                </button>
                @for (c of childPages; track c) {
                  <button
                    mat-menu-item
                    (click)="setLinkUrl(buildChildPageUrl(c))"
                    >
                    <span>{{ c.name || c.id }}</span>
                  </button>
                }
              </ng-template>
            </mat-menu>
          </div>
        }

        @if (!image && !callToAction && !billboardImage && !billboardVideo && !video && !splashVideo) {
          <mat-form-field appearance="outline" class="w-100 pb-2">
            <mat-label>{{'pass.content_description' | translate}}</mat-label>
            <input formControlName="description" type="text" matInput placeholder="{{'pass.content_description' | translate}}" data-nar="media-details-description">
          </mat-form-field>
        }

        @if (!text && !image && !callToAction && !video && !billboardVideo && !billboardImage && !billboardVideo && !video ) {
          <mat-form-field appearance="outline" class="w-100 pb-2">
            <mat-label>{{'pass.copyright' | translate}}</mat-label>
            <input formControlName="copyright" type="text" matInput placeholder="{{'pass.copyright' | translate}}" data-nar="media-details-copyright">
          </mat-form-field>
        }

        @if (!image && !callToAction && !billboardImage && !billboardVideo && !video && !splashVideo ) {
          <mat-form-field appearance="outline" class="w-100 pb-2">
            <mat-label>{{'pass.visibility' | translate}}</mat-label>
            <mat-select formControlName="visibility" class="input-group m-1">
              <mat-option value="visible"><mat-icon>visibility</mat-icon>{{'pass.visible' | translate}}</mat-option>
              <mat-option value="hidden"><mat-icon>visibility_off</mat-icon>{{'pass.hidden' | translate}}</mat-option>
            </mat-select>
          </mat-form-field>
        }

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'pass.altTitle' | translate}}</mat-label>
          <input formControlName="altTitle" type="text" matInput placeholder="{{'pass.altTitle' | translate}}" data-nar="media-details-alt">
        </mat-form-field>

      </form>
    </section>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="cancelChanges()">{{'cancel' | translate}}</button>
  <button
    mat-button
    class="orange-button"
    (click)="saveChanges();"
    [disabled]="!mediaDetailsForm.valid || mediaDetailsForm.get('title').hasError('maxlength')"
    >
    {{ 'apply' | translate }}
  </button>
</mat-dialog-actions>
